// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9Ct1e","right":"styles_right__-IkTH"};